import { WidgetsService } from 'widgets/WidgetsService';
import { IndigoStore } from 'store/store';
import { selectAppMode } from 'app/store/general/selectors';
import {
    isMyPortfolioCapsuleWidgetStrategy,
    WidgetTypeMyPortfolioCapsuleStrategy,
} from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';

export interface MyPortfolioCapsuleServiceOptions {
    widgetsService: WidgetsService;
}

export class MyPortfolioCapsuleService {
    private widgetsService: WidgetsService;
    public store: IndigoStore | undefined;

    public constructor(options: MyPortfolioCapsuleServiceOptions) {
        this.widgetsService = options.widgetsService;
    }

    public getStrategies(): WidgetTypeMyPortfolioCapsuleStrategy[] {
        const ret = this.widgetsService
            .getStrategiesForAvailableWidgets(this.appMode, 'tile')
            .filter((s) => isMyPortfolioCapsuleWidgetStrategy(s.strategy));
        return ret as WidgetTypeMyPortfolioCapsuleStrategy[];
    }

    private get appMode() {
        if (!this.store) {
            throw new Error('store must be set');
        }
        return selectAppMode(this.store.getState());
    }
}
